import CardlessAddressHistoryQuestion from '../components/Questions/CardlessAddressHistoryQuestion'
import CardlessEmploymentHistoryQuestion from '../components/Questions/CardlessEmploymentHistoryQuestion'
import { LoanAmountQuestion } from '../components/Questions/LoanAmountQuestion'
import MaritalStatusQuestion from '../components/Questions/MaritalStatusQuestion'
import { MonthlyIncomeQuestion } from '../components/Questions/MonthlyIncomeQuestion'
import VehicleTypeQuestion from '../components/Questions/VehicleTypeQuestion'
import VehicleRegistrationLookup from '../components/Questions/VehicleRegistrationLookup'
import DateOfBirth from '../components/Questions/DateOfBirth'
import { GroupedQuestionsForReorderingCase } from '../components/Questions/GroupedQuestionsForReorderingCase'
import QuestionComponentProps from './question-component-props'
import QuestionKey from './question-key'
import ContactInfoQuestion from '../components/Questions/ContactInfoQuestion'
import DoubleColumnRadioDrivingLicenceQuestion from '../components/Questions/DrivingLicenceQuestion/DoubleColumnRadioDrivingLicenceQuestion'
import RequiredDetails from '../components/ApplicationForm/RequiredDetails/RequiredDetailsFields'

import type { JSX } from "react"

const QuestionList: Record<QuestionKey, (props: QuestionComponentProps) => JSX.Element> = {
  vehicleRegistration: VehicleRegistrationLookup,
  vehicleType: VehicleTypeQuestion,
  loanAmount: LoanAmountQuestion,
  monthlyIncome: MonthlyIncomeQuestion,
  drivingLicence: DoubleColumnRadioDrivingLicenceQuestion,
  maritalStatus: MaritalStatusQuestion,
  employmentHistory: CardlessEmploymentHistoryQuestion,
  addressHistory: CardlessAddressHistoryQuestion,
  personalDetails: GroupedQuestionsForReorderingCase,
  dateOfBirth: DateOfBirth,
  contactInfo: ContactInfoQuestion,
  requiredDetails: RequiredDetails
}

export default QuestionList
